import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/auth';
// import { useAxiosInterceptors } from '../api';

interface PrivateRouteProps {
  	element: JSX.Element;
}

const PrivateRoute = ({ element, ...rest }: PrivateRouteProps) => {
	
	const location = useLocation()
	const { user, loading} = useAuth();

	// Attach axios interceptors
	// useAxiosInterceptors();
	
	if (loading) {
		// Show a loading indicator while fetching user (to prevent premature redirect)
		return <div>Loading...</div>;
	}
	
	if (!user) {
		return <Navigate to="/login" state={{from:location.pathname}}/>;
	}

	return element;
};

export default PrivateRoute;
